import { combineReducers, Reducer } from '@reduxjs/toolkit';
import app, { AppState } from './app/index';
import brand, { BrandState } from './brand';
import receiverDataStream, {
  ReceiverDataStreamState,
} from './receiver_data_stream/ReceiverDataStreamReducer';
import externalSources, { ExternalSourcesState } from './external_sources/ExternalSourcesReducer';
import catalogue, { BrandCatalogueState } from './catalogue';
import channel from './channel';
import items, { ItemsState } from './items';
import parent, { ParentState } from './parent';
import receiver, { ReceiverState } from './receiver';
import allApplications, { ApplicationListState } from './all_applications';
import resources from './resources';
import settings, { SettingsState } from './settings';
import tools, { ToolState } from './tools';
import user, { UserState } from './user/UserReducer';
import { ResourcesState } from './resources/ResourcesReducer';
import importer, { ImporterState } from './importer/ImporterReducer';
import exporter, { ExporterState } from './exporter/ExporterReducer';
import channelPusher, { ChannelPusherState } from './channelPusher/ChannelPusherReducer';
import distribution, { DistributionState } from './distribution_apiSettings';
import loadSheets, { LoadSheetsState } from './load_sheets/LoadSheetsReducer';
import customAppsSettings, {
  CustomAppsSettingsState,
} from './customApps/CustomAppsSettingsReducer';
import changeLogs, { ChangeLogsState } from './change_logs/ChangeLogsReducer';
import multiAccountUser, {
  MultiAccountUserState,
} from './multiAccountUser/MultiAccountUserReducer';
import customFieldManualOverwrites from './custom_fields/ManualOverwritesReducer';
import { ManualOverwritesState } from '../../types/custom_fields';

export type ApplicationState = {
  app: AppState;
  brand: BrandState;
  receiverDataStream: ReceiverDataStreamState;
  catalogue: BrandCatalogueState;
  channel: any;
  items: ItemsState;
  parent: ParentState;
  receiver: ReceiverState;
  resources: ResourcesState;
  settings: SettingsState;
  tools: ToolState;
  user: UserState;
  allApplications: ApplicationListState;
  importer: ImporterState;
  exporter: ExporterState;
  channelPusher: ChannelPusherState;
  distribution: DistributionState;
  externalSources: ExternalSourcesState;
  loadSheets: LoadSheetsState;
  customAppsSettings: CustomAppsSettingsState;
  changeLogs: ChangeLogsState;
  multiAccountUser: MultiAccountUserState;
  customFieldManualOverwrites: ManualOverwritesState;
};

const appReducer = combineReducers({
  app,
  brand,
  receiverDataStream,
  externalSources,
  catalogue,
  channel,
  items,
  parent,
  receiver,
  resources,
  settings,
  tools,
  user,
  allApplications,
  importer,
  exporter,
  channelPusher,
  distribution,
  loadSheets,
  customAppsSettings,
  changeLogs,
  multiAccountUser,
  customFieldManualOverwrites,
});

const rootReducer: Reducer = (state: any, action) => {
  if (action.type === 'RESET_REDUX') {
    state = { app: { global: state.app.global }, bugsnag: state.bugsnag, user: state.user };
  }
  return appReducer(state, action);
};

export default rootReducer;
